import {
	mapState,
	mapActions
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

export default {
	name: 'student-diapers-quantity',
	data: () => ({
		diaperQuantity: ''
	}),
	computed: {
		...mapState({
			classLevel: (state) => state.Class.selected.schoolClassLevel,
			diapersQuantity: (state) => state.Agenda.agenda.diaperQuantity
		})
	},
	methods: {
		...mapActions([
			'putAgendaDiaperQuantity'
		])
	},
	mounted() {
		this.diapersQuantity;
		EventBus.$on('setStudent', () => {

			this.diaperQuantity = '';

		});
	},
	beforeDestroy() {

		EventBus.$off('setStudent');

	}
};



// WEBPACK FOOTER //
// ./sources/domains/agenda/health/diapers-quantity/student-diapers-quantity.js